export default __webpack_public_path__ + "static/media/img-0269-saudi-arabia-half-face.281f2059.png";